import { render, staticRenderFns } from "./AttachedFiles.vue?vue&type=template&id=c897d6d0&scoped=true&"
import script from "./AttachedFiles.vue?vue&type=script&lang=js&"
export * from "./AttachedFiles.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFiles.vue?vue&type=style&index=0&id=c897d6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897d6d0",
  null
  
)

export default component.exports